// extracted by mini-css-extract-plugin
export var alternate = "_1z-j";
export var black = "_1z-6";
export var blue = "_1z-f";
export var blueLight = "_1z-e";
export var brand = "_1z-8";
export var darkMode = "_1z-b";
export var error = "_1z-a";
export var gray = "_1z-5";
export var grayBlue = "_1z-d";
export var iconWrapper = "_1z-3";
export var inactive = "_1z-7";
export var indigo = "_1z-g";
export var orange = "_1z-i";
export var pink = "_1z-h";
export var primary = "_1z-0";
export var purple = "_1z-9";
export var success = "_1z-4";
export var warning = "_1z-c";
export var white = "_1z-1";
export var whiteSuccess = "_1z-2";